export default __webpack_public_path__ + "static/media/collectible_image.a8eb3ae8.png";